import $ from 'jquery';

window.jquery = window.jQuery = window.$ = $;
